import React, { FC, useContext } from "react";

import { navigate } from "gatsby";

import { isUrlExists } from "@/components/catalog/listing/expertListingBanner/utils";
import { UserContextType } from "@/contexts/User/types";
import UserContext from "@/contexts/User/UserContext";
import MarketingUtils from "@/marketing/marketingUtils";

import { BannerBlockProps } from "./types";

import "./styles.scss";

const BannerBlock = ({ wideBannerData }: BannerBlockProps) => {
  const { userID } = useContext<UserContextType>(UserContext);
  const {
    wideBannerDesktopImage,
    wideBannerMobileImage,
    wideBannerTabletImage,
    wideBannerUrl,
    wideBannerMetric,
    wideBannerHeight,
  } = wideBannerData;

  const onClickHandler = () => {
    if (wideBannerUrl) navigate(wideBannerUrl);
    if (wideBannerMetric?.metricId) {
      MarketingUtils.customMarketingHandler(wideBannerMetric?.metricId, userID);
    }
  };

  return (
    <div className="banner-block__container">
      <picture style={wideBannerHeight ? { height: wideBannerHeight } : {}} className="banner-block" onClick={onClickHandler}>
        {isUrlExists(wideBannerMobileImage) && (
        <source
          srcSet={`
              ${wideBannerMobileImage?.twoX?.url} 2x,
              ${wideBannerMobileImage?.threeX?.url} 3x`}
          media="(max-width: 767px)"
        />
        )}
        {isUrlExists(wideBannerTabletImage) && (
        <source
          srcSet={`
              ${wideBannerTabletImage?.twoX?.url} 2x,
              ${wideBannerTabletImage?.threeX?.url} 3x`}
          media="(max-width: 1199px)"
        />
        )}
        {isUrlExists(wideBannerDesktopImage) && (
        <source
          srcSet={`
              ${wideBannerDesktopImage?.twoX?.url} 2x,
              ${wideBannerDesktopImage?.threeX?.url} 3x`}
          media="(min-width: 1200px)"
        />
        )}
        <img src={wideBannerMobileImage?.twoX?.url} alt="Рекламный баннер" loading="lazy" decoding="async" />
      </picture>
    </div>
  );
};

export default BannerBlock;
